import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface PageHeaderProps {
  readonly actions?: ReactNode;
  readonly subtitle?: ReactNode;
  readonly title: ReactNode;
}

export function PageHeader({ actions, subtitle, title }: PageHeaderProps) {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      sx={{ alignItems: { sm: 'flex-start' }, justifyContent: 'space-between', mb: 3 }}
    >
      <div>
        <Typography component="h1" variant="h4">
          {title}
        </Typography>
        {subtitle === undefined ? null : (
          <Typography color="text.secondary" sx={{ mt: 0.5 }} variant="body1">
            {subtitle}
          </Typography>
        )}
      </div>
      {actions === undefined ? null : (
        <Stack direction="row" spacing={1}>
          {actions}
        </Stack>
      )}
    </Stack>
  );
}
